import React, { memo } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import { Label, Input } from "abs-ui-components";

import {
	INPUT_STEP_VALUE,
	preventScientificNotation,
	roundOff,
} from "../../../services/utilities";

const CIICorrectionFactorsFormGroup = (props) => {
	const { control, setValue } = useFormContext();

	const handleBlur = (field, value) => {
		setValue(field, roundOff(value));
	};

	const transformedData =
		props.vesselData?.VesselCiiCorrectionFactorsDtls?.reduce(
			(result, item) => {
				const key = item.CiiCorrectionFactor;
				const value = item.CiiCorrectionFactorValue;
				result[key] = value;
				return result;
			},
			{}
		);

	return (
		<div className="container-fluid p-0 m-0">
			<MDBRow>
				<MDBCol md="12" className="mt-3">
					<Label
						bold
						name="f(i), capacity factor for ice-classed ships"
						className="mb-1"
					/>
					<Controller
						name="ciiCorrectionsList.capacityFactor"
						control={control}
						defaultValue={
							props?.vesselMstId &&
								transformedData?.capacityFactor !== undefined &&
								transformedData?.capacityFactor !== null
								? roundOff(transformedData?.capacityFactor)
								: ""
						}
						render={({ field }) => (
							<Input
								id="vessel_cii_capacity_factor"
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								className="input-height"
								required
								type="number"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								step={INPUT_STEP_VALUE}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								disabled={
									!props.isEnrollVessel &&
									props.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label
						bold
						name="f(m), factor for ice-classed ships having IA Super and IA"
						className="mb-1"
					/>
					<Controller
						name="ciiCorrectionsList.iceClassFactor"
						control={control}
						defaultValue={
							props?.vesselMstId &&
								transformedData?.iceClassFactor !== undefined &&
								transformedData?.iceClassFactor !== null
								? roundOff(transformedData?.iceClassFactor)
								: ""
						}
						render={({ field }) => (
							<Input
								id="vessel_cii_ice_class_factor"
								disabled={
									!props.isEnrollVessel &&
									props.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								className="input-height"
								required
								type="number"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								step={INPUT_STEP_VALUE}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label
						bold
						name="f(c), cubic capacity correction factor for chemical tankers"
						className="mb-1"
					/>
					<Controller
						name="ciiCorrectionsList.chemicalTankerFactor"
						control={control}
						defaultValue={
							props?.vesselMstId &&
								transformedData?.chemicalTankerFactor !==
								undefined &&
								transformedData?.chemicalTankerFactor !== null
								? roundOff(
									transformedData?.chemicalTankerFactor
								)
								: ""
						}
						render={({ field }) => (
							<Input
								id="vessel_cii_chemical_tanker_factor"
								disabled={
									!props.isEnrollVessel &&
									props.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								className="input-height"
								required
								type="number"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								step={INPUT_STEP_VALUE}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>

				<MDBCol md="12" className="mt-3">
					<Label
						bold
						name="f(i,vse), correction factor for ship-specific voluntary structural enhancement"
						className="mb-1"
					/>
					<Controller
						name="ciiCorrectionsList.voluntaryEnhancementFactor"
						control={control}
						defaultValue={
							props?.vesselMstId &&
								transformedData?.voluntaryEnhancementFactor !==
								undefined &&
								transformedData?.voluntaryEnhancementFactor !== null
								? roundOff(
									transformedData?.voluntaryEnhancementFactor
								)
								: ""
						}
						render={({ field }) => (
							<Input
								id="vessel_cii_voluntary_enhancement_factor"
								disabled={
									!props.isEnrollVessel &&
									props.vesselMstId &&
									(props?.regulations?.trim() === "EUMRV" ||
										"UKMRV" ||
										"DCS")
								}
								autoFocus={false}
								value={field.value}
								onChange={field.onChange}
								className="input-height"
								required
								type="number"
								onBlur={(e) =>
									handleBlur(field.name, field.value)
								}
								step={INPUT_STEP_VALUE}
								onKeyDown={(e) => {
									preventScientificNotation(e);
									// Prevent up and down arrow keys
									if (
										e.key === "ArrowUp" ||
										e.key === "ArrowDown"
									) {
										e.preventDefault();
									}
								}}
								onWheel={(e) => e.target.blur()}
								maxLength={7}
								onInput={(e) => {
									if (e.target.value.length > 7) {
										e.target.value = e.target.value.slice(
											0,
											7
										);
									}
								}}
							/>
						)}
					/>
				</MDBCol>
			</MDBRow>
		</div>
	);
};

export default memo(CIICorrectionFactorsFormGroup);
